"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var Collection_1 = __importDefault(require("../../Collection"));

var client_1 = __importDefault(require("../client"));
/**
* Collection generated by the Stories-API endpoint.
*/


var StoriesAPICollection = function StoriesAPICollection(_a) {
  var apiKey = _a.apiKey,
      data = _a.data,
      endpoint = _a.endpoint,
      errorComponent = _a.errorComponent,
      id = _a.id,
      onChange = _a.onChange,
      onLoad = _a.onLoad,
      options = _a.options,
      page = _a.page,
      q = _a.q,
      urlFormatter = _a.urlFormatter;

  var _b = (0, react_1.useState)(false),
      collectionLoading = _b[0],
      setCollectionLoading = _b[1];

  var _c = (0, react_1.useState)(false),
      storiesLoading = _c[0],
      setStoriesLoading = _c[1];

  var _d = (0, react_1.useState)(data),
      collectionData = _d[0],
      setCollectionData = _d[1];

  var _e = (0, react_1.useState)([]),
      storiesData = _e[0],
      setStoriesData = _e[1]; // TODO: support as prop


  var _f = (0, react_1.useState)(false),
      error = _f[0],
      setError = _f[1];

  var _g = (0, react_1.useState)(q),
      search = _g[0],
      setSearch = _g[1]; // Only set when hitting 'enter'


  var _h = (0, react_1.useState)(q),
      userInput = _h[0],
      setUserInput = _h[1]; // Tracks the search input before 'enter'


  var _j = (0, react_1.useState)(page),
      currentPage = _j[0],
      setCurrentPage = _j[1];

  var _k = (0, react_1.useState)(undefined),
      pageCount = _k[0],
      setPageCount = _k[1];

  var _l = (0, react_1.useState)(undefined),
      storyCount = _l[0],
      setStoryCount = _l[1];

  var client = endpoint ? new client_1.default(endpoint, apiKey) : undefined;

  var handleError = function handleError() {
    return setError(true);
  };

  var loading = collectionLoading || storiesLoading;

  var handleChange = function handleChange() {
    // Used for a public interface of capturing key events
    if (onChange) onChange({
      page: currentPage,
      q: search
    });
  };

  var fetchCollection = function fetchCollection() {
    if (!client) {
      handleError();
      return;
    }

    setCollectionLoading(true);
    client.collection("" + id, function (apiData) {
      setCollectionData(apiData);
      if (onLoad) onLoad(apiData);
      setCollectionLoading(false);
    }, handleError).then();
  };

  var fetchStories = function fetchStories() {
    if (!client) {
      handleError();
      return;
    }

    setStoriesLoading(true);
    client.story('', id, currentPage, search, function (res) {
      setStoriesData(res.items);
      setCurrentPage(res.page);
      setPageCount(res.last_page);
      setStoryCount(res.total_count);
      setSearch(res.q);
      handleChange();
      setStoriesLoading(false);
    }, handleError).then();
  };

  (0, react_1.useEffect)(function () {
    if (data || collectionData || collectionLoading) return;
    fetchCollection();
  }, [collectionData]);
  (0, react_1.useEffect)(function () {
    if (storiesLoading) return;
    fetchStories();
  }, [storiesData, currentPage, search]);

  var handlePageChange = function handlePageChange(_a) {
    var selected = _a.selected;
    var newPage = selected + 1;
    if (newPage === currentPage) return;
    setCurrentPage(newPage);
  };

  var handleSearchInput = function handleSearchInput(event) {
    return setUserInput((event === null || event === void 0 ? void 0 : event.target).value);
  };

  var handleSearch = function handleSearch(event) {
    event.preventDefault(); // prevent form from reloading page

    setCurrentPage(1);
    setSearch(userInput);
  };

  var renderError = function renderError() {
    return errorComponent || react_1.default.createElement(Typography_1.default, null, "Something went wrong while loading this collection...", react_1.default.createElement("br", null), "Try Refreshing or Check Back Soon");
  };
  /* eslint-disable react/jsx-props-no-spreading */


  return error ? renderError() : react_1.default.createElement(Collection_1.default, __assign({
    loading: loading,
    stories: storiesData
  }, collectionData, {
    count: storyCount || 0,
    page: currentPage || 0,
    pageCount: pageCount || 0,
    onPageChange: handlePageChange,
    search: userInput,
    q: q,
    onSearch: handleSearch,
    onSearchInput: handleSearchInput,
    urlFormatter: urlFormatter
  }, options));
};

StoriesAPICollection.propTypes = {
  /** API Key to interact with the StoriesAPI */
  apiKey: prop_types_1.default.string.isRequired,

  /** Override `StoriesAPI` data fetching to use custom data */
  // eslint-disable-next-line react/forbid-prop-types
  data: prop_types_1.default.object,

  /** `StoriesAPI` endpoint URL */
  endpoint: prop_types_1.default.string,

  /** StoriesAPI collection id */
  id: prop_types_1.default.number.isRequired,

  /** Props to pass to the `Story` component */
  // eslint-disable-next-line react/forbid-prop-types
  options: prop_types_1.default.object,

  /** Current Browsing Page Number */
  page: prop_types_1.default.number
};
StoriesAPICollection.defaultProps = {
  data: undefined,
  endpoint: undefined,
  options: {},
  page: 1
};
exports.default = StoriesAPICollection;